import AuditLogs from './AuditLogs';

export default AuditLogs;
